var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5425 6.58058C13.5777 6.51537 13.6458 6.47471 13.7199 6.47471L16.0559 6.47461C16.2081 6.4746 16.3055 6.63687 16.2338 6.77117L10.55 17.4169C10.515 17.4825 10.4466 17.5235 10.3722 17.5235L7.97547 17.5236C7.82284 17.5236 7.72556 17.3606 7.79804 17.2263L13.5425 6.58058Z",
    fill: "#FF5824"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2847 6.58058C19.3199 6.51537 19.388 6.47471 19.4621 6.47471L21.7981 6.47461C21.9503 6.4746 22.0477 6.63687 21.976 6.77117L16.2922 17.4169C16.2572 17.4825 16.1888 17.5235 16.1144 17.5235L13.7177 17.5236C13.565 17.5236 13.4678 17.3606 13.5402 17.2263L19.2847 6.58058Z",
    fill: "#FF5824"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76896 6.58058C7.80415 6.51537 7.87227 6.47471 7.94637 6.47471L10.2823 6.47461C10.4346 6.4746 10.5319 6.63687 10.4602 6.77117L4.77644 17.4169C4.74139 17.4825 4.67302 17.5235 4.5986 17.5235L2.2019 17.5236C2.04926 17.5236 1.95198 17.3606 2.02446 17.2263L7.76896 6.58058Z",
    fill: "#FF5824"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxur);
export default __webpack_public_path__ + "static/media/Axur.7ee07077e274da3318f4b0e607a6e5cb.svg";
export { ForwardRef as ReactComponent };